

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { MdContentCopy } from "react-icons/md";
// import { toast } from 'react-toastify'; // Import toast

// // Import CSS files
// import "../../Dashboard Style/core.css";
// import "../../Dashboard Style/flatpickr.min.css";
// import "../../assets1/css/custom.css";
// import "../../assets1/css/style.css";

// // Import images
// import logo from "../../assets1/images/logo.webp";
// import usFlag from "../../assets1/images/flags/us.svg";
// import frFlag from "../../assets1/images/flags/fr.svg";
// import face2 from "../../assets1/images/faces/face2.webp";
// import face3 from "../../assets1/images/faces/face3.webp";

// import Sidebar from '../Core/Sidebar';
// import Navbar from '../Core/Navbar';

// const FuelDeposit = () => {
//   const navigate = useNavigate();
//   const authToken = useSelector((state) => state.user?.token);
//   const userData = useSelector((state) => state.user?.userData);
//   const [openDropdowns, setOpenDropdowns] = useState({});
//   const [paymentReports, setPaymentReports] = useState([]);
//   const [filters, setFilters] = useState({
//     date: "",
//     month: "",
//     year: ""
//   });
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [isLoading, setIsLoading] = useState(false);
//   const [totalAmount, setTotalAmount] = useState(0);
//   const [totalCount, setTotalCount] = useState(0);
//   const [copiedId, setCopiedId] = useState(null);

//   // Add toggle sidebar function
//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   // Initialize sidebar functionality
//   useEffect(() => {
//     const sidebar = document.querySelector('.sidebar');
//     const sidebarBody = document.querySelector('.sidebar-body');
    
//     if (sidebar) {
//       if (sidebarOpen) {
//         sidebar.classList.remove('close');
//       } else {
//         sidebar.classList.add('close');
//       }
//     }
    
//     if (sidebarBody) {
//       sidebarBody.style.height = 'calc(100vh - 70px)';
//       sidebarBody.style.overflowY = 'auto';
//     }

//     const initialDropdownState = {
//       dashboard: false,
//       fundManagement: false,
//       registrationTeam: false,
//       incomeEarnings: false,
//       bonanzaRewards: false,
//       airdrop: false,
//       withdrawal: false,
//       settings: false
//     };
//     setOpenDropdowns(initialDropdownState);

//     return () => {
//       // Cleanup
//     };
//   }, [sidebarOpen]);

//   useEffect(() => {
//     // Add custom scrollbar styles for sidebar
//     const style = document.createElement('style');
//     style.innerHTML = `
//       /* Custom scrollbar for sidebar */
//       .sidebar-body {
//         height: calc(100vh - 70px);
//         overflow-y: auto;
//       }
      
//       .sidebar-body::-webkit-scrollbar {
//         width: 6px;
//       }
      
//       .sidebar-body::-webkit-scrollbar-track {
//         background: rgba(255, 255, 255, 0.05);
//         border-radius: 10px;
//       }
      
//       .sidebar-body::-webkit-scrollbar-thumb {
//         background: rgba(255, 255, 255, 0.2);
//         border-radius: 10px;
//       }
      
//       .sidebar-body::-webkit-scrollbar-thumb:hover {
//         background: rgba(255, 255, 255, 0.3);
//       }
      
//       /* Sidebar dropdown menu styles */
//       .sidebar .nav-dropdown {
//         list-style: none;
//         padding-left: 0;
//         max-height: 0;
//         overflow: hidden;
//         transition: max-height 0.3s ease;
//       }
      
//       .sidebar .nav-dropdown.show {
//         max-height: 500px;
//       }
      
//       .sidebar .nav-dropdown-item {
//         padding-left: 2.5rem;
//       }
      
//       /* Sidebar dropdown toggle with icon */
//       .nav-item.has-dropdown .nav-link {
//         position: relative;
//         padding-right: 2.5rem;
//       }
      
//       .nav-item.has-dropdown .dropdown-icon {
//         position: absolute;
//         right: 1rem;
//         top: 50%;
//         transform: translateY(-50%);
//         transition: transform 0.3s ease;
//       }
      
//       .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
//         transform: translateY(-50%) rotate(180deg);
//       }
      
//       /* Improved dropdown styling similar to first image */
//       .nav-item.has-dropdown .nav-dropdown {
//         background: rgba(255, 255, 255, 0.05);
//         border-left: 3px solid var(--primary-color, #0d6efd);
//         margin-left: 1rem;
//         border-radius: 0 0 8px 8px;
//       }
      
//       .nav-item.has-dropdown .nav-dropdown-item .nav-link {
//         padding: 0.75rem 1rem 0.75rem 2rem;
//         color: rgba(255, 255, 255, 0.8);
//       }
      
//       .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
//         background: rgba(255, 255, 255, 0.1);
//         color: white;
//       }
      
//       /* Fix for category text styling */
//       .nav-item.has-dropdown .link-title.nav-item.nav-category {
//         font-weight: 600;
//         font-size: 0.875rem;
//         text-transform: uppercase;
//         letter-spacing: 0.5px;
//       }
      
//       /* Smooth transitions */
//       .sidebar {
//         transition: all 0.3s ease;
//       }
      
//       /* Copy button styles */
//       .copy-btn {
//         transition: all 0.2s ease;
//         opacity: 0.7;
//       }
      
//       .copy-btn:hover {
//         opacity: 1;
//         transform: scale(1.1);
//       }
      
//       /* Tooltip for copy feedback */
//       .copy-tooltip {
//         position: absolute;
//         top: -30px;
//         left: 50%;
//         transform: translateX(-50%);
//         background: #28a745;
//         color: white;
//         padding: 4px 8px;
//         border-radius: 4px;
//         font-size: 12px;
//         white-space: nowrap;
//         z-index: 1000;
//         animation: fadeInOut 2s ease;
//       }
      
//       .copy-tooltip:after {
//         content: '';
//         position: absolute;
//         bottom: -5px;
//         left: 50%;
//         transform: translateX(-50%);
//         border-left: 5px solid transparent;
//         border-right: 5px solid transparent;
//         border-top: 5px solid #28a745;
//       }
      
//       @keyframes fadeInOut {
//         0% { opacity: 0; transform: translateX(-50%) translateY(5px); }
//         20% { opacity: 1; transform: translateX(-50%) translateY(0); }
//         80% { opacity: 1; transform: translateX(-50%) translateY(0); }
//         100% { opacity: 0; transform: translateX(-50%) translateY(-5px); }
//       }
      
//       /* Make hash text selectable and clickable */
//       .hash-text {
//         cursor: pointer;
//         transition: color 0.2s ease;
//         user-select: none;
//       }
      
//       .hash-text:hover {
//         color: #007bff !important;
//       }
      
//       /* Responsive adjustments for table */
//       @media (max-width: 768px) {
//         .table-responsive {
//           font-size: 14px;
//         }
        
//         .copy-btn {
//           padding: 2px !important;
//           min-width: 20px !important;
//           min-height: 20px !important;
//         }
//       }
//     `;
//     document.head.appendChild(style);

//     // Load Fuel Deposit
//     fetchPaymentReports();

//     // Initialize Lucide icons
//     if (window.lucide) {
//       window.lucide.createIcons();
//     }

//     return () => {
//       document.head.removeChild(style);
//     };
//   }, []);

//   // Toggle dropdown function
//   const toggleDropdown = (key) => {
//     setOpenDropdowns((prev) => ({
//       ...prev,
//       [key]: !prev[key],
//     }));
//   };

//   const fetchPaymentReports = async (filterParams = {}) => {
//     setIsLoading(true);
    
//     try {
//       const queryParams = new URLSearchParams();
      
//       if (filterParams.date) {
//         queryParams.append('date', filterParams.date);
//       }
//       if (filterParams.month) {
//         queryParams.append('month', filterParams.month);
//       }
//       if (filterParams.year) {
//         queryParams.append('year', filterParams.year);
//       }
      
//       const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
      
//       const response = await fetch(
//         `https://global.thewillowquantum.com/api/user/get-register-payment-list${queryString}`,
//         {
//           method: 'GET',
//           headers: {
//             'Authorization': `Bearer ${authToken}`,
//             'Accept': 'application/json',
//             'Content-Type': 'application/json',
//           }
//         }
//       );

//       if (response.status === 401) {
//         toast.error("Session expired. Please log in again.");
//         navigate('/signin');
//         return;
//       }

//       const result = await response.json();

//       if (result.status) {
//         const transformedData = result.data.map(item => ({
//           id: item.id,
//           paymentMode: item.payment_mode,
//           paymentHash: item.payment_hash_id,
//           paymentAmount: item.payment_amount,
//           paymentReceiveHash: item.payment_receive_hash_id,
//           paymentStatus: item.payment_status,
//           paymentComment: item.payment_comment,
//           statusUpdateAt: item.payment_status_update_at,
//           createdAt: item.created_at,
//           firstName: "User",
//           lastName: "",
//           accountName: item.payment_receive_hash_id ? item.payment_receive_hash_id.substring(0, 8) : "N/A",
//           mobile: "N/A",
//           country: "N/A",
//           submissionDate: item.created_at,
//           approvalDate: item.payment_status === "Approved" ? item.payment_status_update_at : null,
//           status: item.payment_status
//         }));
        
//         setPaymentReports(transformedData);
        
//         const totalAmt = transformedData.reduce((sum, item) => sum + item.paymentAmount, 0);
//         setTotalAmount(totalAmt);
//         setTotalCount(transformedData.length);
        
//         toast.success("Fuel Deposit loaded successfully!");
//       } else {
//         toast.error(result.message || "Failed to load Fuel Deposit");
//       }
//     } catch (error) {
//       console.error("Error fetching Fuel Deposit:", error);
//       toast.error("Network error. Please check your connection.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const applyFilters = () => {
//     fetchPaymentReports(filters);
//   };

//   const clearFilters = () => {
//     setFilters({
//       date: "",
//       month: "",
//       year: ""
//     });
//     fetchPaymentReports();
//   };

//   const exportToExcel = () => {
//     if (paymentReports.length === 0) {
//       toast.warning("No data to export");
//       return;
//     }

//     const exportData = paymentReports.map(report => ({
//       'ID': report.id,
//       'Payment Mode': report.paymentMode,
//       'Payment Hash ID': report.paymentHash,
//       'Payment Amount': `$${report.paymentAmount}`,
//       'Receiver Hash ID': report.paymentReceiveHash,
//       'Status': report.paymentStatus,
//       'Comment': report.paymentComment || 'N/A',
//       'Created At': report.createdAt,
//       'Status Updated At': report.statusUpdateAt || 'N/A'
//     }));

//     const csvContent = "data:text/csv;charset=utf-8,"
//       + [Object.keys(exportData[0]).join(",")]
//         .concat(exportData.map(row => Object.values(row).map(value =>
//           `"${value}"`).join(",")))
//         .join("\n");

//     const encodedUri = encodeURI(csvContent);
//     const link = document.createElement("a");
//     link.setAttribute("href", encodedUri);
//     link.setAttribute("download", `payment-reports-${new Date().toISOString().split('T')[0]}.csv`);
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);

//     toast.success("Report exported to CSV successfully!");
//   };

//   const exportToPDF = () => {
//     if (paymentReports.length === 0) {
//       toast.warning("No data to export");
//       return;
//     }
    
//     toast.info("PDF export feature coming soon!");
//   };

//   // Enhanced copy function with tooltip feedback
//   const copyToClipboard = (text, fieldName = "text", id = null) => {
//     if (!text) {
//       toast.warning(`No ${fieldName} to copy`);
//       return;
//     }
    
//     navigator.clipboard.writeText(text)
//       .then(() => {
//         // Show temporary tooltip
//         if (id) {
//           setCopiedId(id);
//           setTimeout(() => setCopiedId(null), 2000);
//         }
//         toast.success(`${fieldName} copied to clipboard!`);
//       })
//       .catch(err => {
//         console.error('Failed to copy: ', err);
//         toast.error("Failed to copy to clipboard");
//       });
//   };

//   // Format text for display
//   const formatText = (text, maxLength = 20) => {
//     if (!text) return 'N/A';
//     if (text.length <= maxLength) return text;
//     return `${text.substring(0, maxLength)}...`;
//   };

//   // Function to format date
//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     const date = new Date(dateString);
//     return date.toLocaleString();
//   };

//   // Function to get status badge class
//   const getStatusBadgeClass = (status) => {
//     switch (status) {
//       case 'Approved':
//         return 'bg-success';
//       case 'Pending':
//         return 'bg-warning text-dark';
//       case 'Rejected':
//       case 'Failed':
//         return 'bg-danger';
//       default:
//         return 'bg-secondary';
//     }
//   };

//   return (
//     <div className="main-wrapper">
//       {/* Sidebar */}
//       <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
//         <div className="sidebar-header">
//           <a href="#" className="sidebar-brand" onClick={(e) => { e.preventDefault(); navigate('/dashboard'); }}>
//             <i className="me-2" data-lucide="atom"></i>
//             Willow <span>Quantum</span>
//           </a>
//           <div className="sidebar-toggler" onClick={toggleSidebar}>
//             <span></span>
//             <span></span>
//             <span></span>
//           </div>
//         </div>
       
//          <Sidebar />
//       </nav>

//       <div className="page-wrapper">
//        <Navbar toggleSidebar={toggleSidebar} />

//         {/* Page Content */}
//         <div className="page-content container-xxl">
//           {/* Page Header */}
//           <div className="row mb-4">
//             <div className="col-12">
//               <div>
//                 <h4 className="fw-bold mb-1">
//                   <i className="me-2" data-lucide="file-text"></i>
//                   Fuel Deposit
//                 </h4>
//                 <p >View and manage all Fuel Deposit</p>
//               </div>
//             </div>
//           </div>

//           {/* Fuel Deposit Card */}
//           <div className="row">
//             <div className="col-12">
//               <div className="card custom-card">
//                 <div className="top-left"></div>
//                 <div className="top-right"></div>
//                 <div className="bottom-left"></div>
//                 <div className="bottom-right"></div>
//                 <div className="card-body">
//                   <div className="d-flex justify-content-between align-items-baseline mb-3">
//                     <h6 className="card-title mb-0">
//                       <i className="me-2" data-lucide="file-text"></i>
//                       Fuel Deposit List
//                     </h6>
//                     {isLoading && (
//                       <div className="spinner-border spinner-border-sm text-primary" role="status">
//                         <span className="visually-hidden">Loading...</span>
//                       </div>
//                     )}
//                   </div>

//                   <div className="table-responsive">
//                     <table className="table table-hover">
//                       <thead>
//                         <tr>
//                           <th>Sl no.</th>
//                           <th>Amount</th>
//                           <th>Hash ID</th>
//                           <th>Status</th>
//                           <th>Created At</th>
//                           <th>Updated At</th>
//                           <th>Comment</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {isLoading ? (
//                           <tr>
//                             <td colSpan="9" className="text-center py-5">
//                               <div className="spinner-border text-primary" role="status">
//                                 <span className="visually-hidden">Loading...</span>
//                               </div>
//                               <p className="mt-2 ">Loading Fuel Deposit...</p>
//                             </td>
//                           </tr>
//                         ) : paymentReports.length > 0 ? (
//                           paymentReports.map((report, index) => {
//                             const paymentHashId = `payment-${report.id}`;
//                             const receiverHashId = `receiver-${report.id}`;
                            
//                             return (
//                               <tr key={report.id}>
//                                 <td>{index + 1}</td>
//                                 <td>
//                                   <span className="badge bg-warning text-dark">
//                                     {report.paymentMode}
//                                   </span>
//                                 </td>
                                
//                                 {/* Payment Hash ID with Copy Button */}
//                                 <td>
//                                   <div className="d-flex align-items-center gap-2 position-relative">
//                                     <small 
//                                       className=" hash-text" 
//                                       title={report.paymentHash || 'N/A'}
//                                       style={{ 
//                                         wordBreak: 'break-all',
//                                         flex: 1,
//                                         color: "white"
//                                       }}
//                                       onClick={() => copyToClipboard(report.paymentHash, "Payment Hash ID", paymentHashId)}
//                                     >
//                                       {formatText(report.paymentHash, 15)}
//                                     </small>
//                                     <div className="position-relative">
//                                       <button
//                                         className="btn btn-sm btn-outline-secondary p-1 copy-btn"
//                                         onClick={() => copyToClipboard(report.paymentHash, "Payment Hash ID", paymentHashId)}
//                                         title="Copy Payment Hash ID"
//                                         style={{ 
//                                           minWidth: '24px',
//                                           minHeight: '24px',
//                                           display: 'flex',
//                                           alignItems: 'center',
//                                           justifyContent: 'center'
//                                         }}
//                                       >
//                                         <MdContentCopy size={14} />
//                                       </button>
//                                       {copiedId === paymentHashId && (
//                                         <div className="copy-tooltip">
//                                           Copied!
//                                         </div>
//                                       )}
//                                     </div>
//                                   </div>
//                                 </td>
                                
                               
                                
//                                 <td>
//                                   <span className={`badge ${getStatusBadgeClass(report.paymentStatus)}`}>
//                                     {report.paymentStatus}
//                                   </span>
//                                 </td>
//                                 <td>
//                                   <small>{formatDate(report.createdAt)}</small>
//                                 </td>
//                                 <td>
//                                   <small>
//                                     {report.statusUpdateAt ? formatDate(report.statusUpdateAt) : 'N/A'}
//                                   </small>
//                                 </td>
//                                 <td>
//                                   <small className="">
//                                     {report.paymentComment || 'No comment'}
//                                   </small>
//                                 </td>
//                               </tr>
//                             );
//                           })
//                         ) : (
//                           <tr>
//                             <td colSpan="9" className="text-center py-4">
//                               <i data-lucide="inbox" className="icon-lg  mb-2"></i>
//                               <p className=" mb-0">No Fuel Deposit found</p>
//                               <button 
//                                 className="btn btn-sm btn-link mt-2"
//                                 onClick={() => fetchPaymentReports()}
//                               >
//                                 <i className="me-1" data-lucide="refresh-cw"></i> Refresh
//                               </button>
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Footer */}
//         <footer className="footer d-flex flex-row align-items-center justify-content-center px-4 py-3 border-top small">
//           <p className="text-secondary mb-1 mb-md-0">Copyright © 2025 Willow Quantum. All Right Reserved.</p>
//         </footer>
//       </div>
//     </div>
//   );
// };

// export default FuelDeposit;



import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { MdContentCopy } from "react-icons/md";
import { toast } from 'react-toastify'; // Import toast

// Import CSS files
import "../../Dashboard Style/core.css";
import "../../Dashboard Style/flatpickr.min.css";
import "../../assets1/css/custom.css";
import "../../assets1/css/style.css";

// Import images
import logo from "../../assets1/images/logo.webp";
import usFlag from "../../assets1/images/flags/us.svg";
import frFlag from "../../assets1/images/flags/fr.svg";
import face2 from "../../assets1/images/faces/face2.webp";
import face3 from "../../assets1/images/faces/face3.webp";

import Sidebar from '../Core/Sidebar';
import Navbar from '../Core/Navbar';
import { getFuelWalletPaymentListApi, getRegisterPaymentListApi } from "../../Services/Operations/ProductAPI";

const FuelDeposit = () => {
  const navigate = useNavigate();
  const authToken = useSelector((state) => state.user?.token);
  const userData = useSelector((state) => state.user?.userData);
  const [openDropdowns, setOpenDropdowns] = useState({});
  const [paymentReports, setPaymentReports] = useState([]);
  const [filters, setFilters] = useState({
    date: "",
    month: "",
    year: ""
  });
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [copiedId, setCopiedId] = useState(null);

      const [isMobile, setIsMobile] = useState(false);
  
    // Check screen size on mount and resize
    useEffect(() => {
      const checkMobile = () => {
        const mobile = window.innerWidth < 992;
        setIsMobile(mobile);
  
        // Auto-close sidebar on mobile by default
        if (mobile) {
          setSidebarOpen(true);
        } else {
          setSidebarOpen(true);
        }
      };
  
      checkMobile();
      window.addEventListener('resize', checkMobile);
      return () => window.removeEventListener('resize', checkMobile);
    }, []);
  
  
  
    const closeSidebar = () => {
      if (isMobile) {
        setSidebarOpen(false);
      }
    };


  // Add toggle sidebar function
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Initialize sidebar functionality
  useEffect(() => {
    const sidebar = document.querySelector('.sidebar');
    const sidebarBody = document.querySelector('.sidebar-body');
    
    if (sidebar) {
      if (sidebarOpen) {
        sidebar.classList.remove('close');
      } else {
        sidebar.classList.add('close');
      }
    }
    
    if (sidebarBody) {
      sidebarBody.style.height = 'calc(100vh - 70px)';
      sidebarBody.style.overflowY = 'auto';
    }

    const initialDropdownState = {
      dashboard: false,
      fundManagement: false,
      registrationTeam: false,
      incomeEarnings: false,
      bonanzaRewards: false,
      airdrop: false,
      withdrawal: false,
      settings: false
    };
    setOpenDropdowns(initialDropdownState);

    return () => {
      // Cleanup
    };
  }, [sidebarOpen]);

  useEffect(() => {
    // Add custom scrollbar styles for sidebar
    const style = document.createElement('style');
    style.innerHTML = `
      /* Custom scrollbar for sidebar */
      .sidebar-body {
        height: calc(100vh - 70px);
        overflow-y: auto;
      }
      
      .sidebar-body::-webkit-scrollbar {
        width: 6px;
      }
      
      .sidebar-body::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.3);
      }
      
      /* Sidebar dropdown menu styles */
      .sidebar .nav-dropdown {
        list-style: none;
        padding-left: 0;
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease;
      }
      
      .sidebar .nav-dropdown.show {
        max-height: 500px;
      }
      
      .sidebar .nav-dropdown-item {
        padding-left: 2.5rem;
      }
      
      /* Sidebar dropdown toggle with icon */
      .nav-item.has-dropdown .nav-link {
        position: relative;
        padding-right: 2.5rem;
      }
      
      .nav-item.has-dropdown .dropdown-icon {
        position: absolute;
        right: 1rem;
        top: 50%;
        transform: translateY(-50%);
        transition: transform 0.3s ease;
      }
      
      .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
        transform: translateY(-50%) rotate(180deg);
      }
      
      /* Improved dropdown styling similar to first image */
      .nav-item.has-dropdown .nav-dropdown {
        background: rgba(255, 255, 255, 0.05);
        border-left: 3px solid var(--primary-color, #0d6efd);
        margin-left: 1rem;
        border-radius: 0 0 8px 8px;
      }
      
      .nav-item.has-dropdown .nav-dropdown-item .nav-link {
        padding: 0.75rem 1rem 0.75rem 2rem;
        color: rgba(255, 255, 255, 0.8);
      }
      
      .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
        background: rgba(255, 255, 255, 0.1);
        color: white;
      }
      
      /* Fix for category text styling */
      .nav-item.has-dropdown .link-title.nav-item.nav-category {
        font-weight: 600;
        font-size: 0.875rem;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
      
      /* Smooth transitions */
      .sidebar {
        transition: all 0.3s ease;
      }
      
      /* Copy button styles */
      .copy-btn {
        transition: all 0.2s ease;
        opacity: 0.7;
      }
      
      .copy-btn:hover {
        opacity: 1;
        transform: scale(1.1);
      }
      
      /* Tooltip for copy feedback */
      .copy-tooltip {
        position: absolute;
        top: -30px;
        left: 50%;
        transform: translateX(-50%);
        background: #28a745;
        color: white;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 12px;
        white-space: nowrap;
        z-index: 1000;
        animation: fadeInOut 2s ease;
      }
      
      .copy-tooltip:after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 50%;
        transform: translateX(-50%);
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid #28a745;
      }
      
      @keyframes fadeInOut {
        0% { opacity: 0; transform: translateX(-50%) translateY(5px); }
        20% { opacity: 1; transform: translateX(-50%) translateY(0); }
        80% { opacity: 1; transform: translateX(-50%) translateY(0); }
        100% { opacity: 0; transform: translateX(-50%) translateY(-5px); }
      }
      
      /* Make hash text selectable and clickable */
      .hash-text {
        cursor: pointer;
        transition: color 0.2s ease;
        user-select: none;
      }
      
      .hash-text:hover {
        color: #007bff !important;
      }
      
      /* Responsive adjustments for table */
      @media (max-width: 768px) {
        .table-responsive {
          font-size: 14px;
        }
        
        .copy-btn {
          padding: 2px !important;
          min-width: 20px !important;
          min-height: 20px !important;
        }
      }
    `;
    document.head.appendChild(style);

    // Load Fuel Deposit
    fetchPaymentReports();

    // Initialize Lucide icons
    if (window.lucide) {
      window.lucide.createIcons();
    }

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Toggle dropdown function
  const toggleDropdown = (key) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

const fetchPaymentReports = async (filterParams = {}) => {
    setIsLoading(true);
    
    try {
        const result = await getFuelWalletPaymentListApi(authToken, filterParams);

        if (result.status) {
            setPaymentReports(result.data);
            
            // Update totals from API response
            setTotalAmount(result.summary?.totalAmount || 0);
            setTotalCount(result.summary?.totalCount || 0);
            
            // Show success toast only if we have data
            if (result.data.length > 0) {
                // toast.success(result.message || "Fuel deposits loaded successfully!");
            } else {
                // toast.info("No fuel deposits found");
            }
        } else {
            // toast.error(result.message || "Failed to load fuel deposits");
            
            // If session expired, redirect to login
            if (result.message.includes('Session expired') || result.message.includes('Unauthorized')) {
                setTimeout(() => {
                    navigate('/signin');
                }, 1500);
            }
        }
    } catch (error) {
        console.error("Error fetching fuel deposits:", error);
        toast.error("Network error. Please check your connection.");
    } finally {
        setIsLoading(false);
    }
};
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const applyFilters = () => {
    fetchPaymentReports(filters);
  };

  const clearFilters = () => {
    setFilters({
      date: "",
      month: "",
      year: ""
    });
    fetchPaymentReports();
  };

  const exportToExcel = () => {
    if (paymentReports.length === 0) {
      toast.warning("No data to export");
      return;
    }

    const exportData = paymentReports.map(report => ({
      'ID': report.id,
      'Payment Mode': report.paymentMode,
      'Payment Hash ID': report.paymentHash,
      'Payment Amount': `$${report.paymentAmount}`,
      'Receiver Hash ID': report.paymentReceiveHash,
      'Status': report.paymentStatus,
      'Comment': report.paymentComment || 'N/A',
      'Created At': report.createdAt,
      'Status Updated At': report.statusUpdateAt || 'N/A'
    }));

    const csvContent = "data:text/csv;charset=utf-8,"
      + [Object.keys(exportData[0]).join(",")]
        .concat(exportData.map(row => Object.values(row).map(value =>
          `"${value}"`).join(",")))
        .join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `payment-reports-${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    toast.success("Report exported to CSV successfully!");
  };

  const exportToPDF = () => {
    if (paymentReports.length === 0) {
      toast.warning("No data to export");
      return;
    }
    
    toast.info("PDF export feature coming soon!");
  };

  // Enhanced copy function with tooltip feedback
  const copyToClipboard = (text, fieldName = "text", id = null) => {
    if (!text) {
      toast.warning(`No ${fieldName} to copy`);
      return;
    }
    
    navigator.clipboard.writeText(text)
      .then(() => {
        // Show temporary tooltip
        if (id) {
          setCopiedId(id);
          setTimeout(() => setCopiedId(null), 2000);
        }
        toast.success(`${fieldName} copied to clipboard!`);
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
        toast.error("Failed to copy to clipboard");
      });
  };

  // Format text for display
  const formatText = (text, maxLength = 20) => {
    if (!text) return 'N/A';
    if (text.length <= maxLength) return text;
    return `${text.substring(0, maxLength)}...`;
  };

  // Function to format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  // Function to get status badge class
  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'Approved':
        return 'bg-success';
      case 'Pending':
        return 'bg-warning text-dark';
      case 'Rejected':
      case 'Failed':
        return 'bg-danger';
      default:
        return 'bg-secondary';
    }
  };

  return (
    <div className="main-wrapper">
      {/* Sidebar */}
      <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
        <div className="sidebar-header">
          <a href="#" className="sidebar-brand" onClick={(e) => { e.preventDefault(); navigate('/dashboard'); }}>
            <i className="me-2" data-lucide="atom"></i>
            Willow <span>Quantum</span>
          </a>
          <div className="sidebar-toggler" onClick={toggleSidebar}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
       
        <Sidebar
                          isOpen={!sidebarOpen}
                          onClose={closeSidebar}
                        />
              
                        {/* Mobile backdrop */}
                        {isMobile && sidebarOpen && (
                          <div
                            className="sidebar-backdrop"
                            onClick={closeSidebar}
                          />
                        )}
             </nav>
       
             <div className="page-wrapper">
               <Navbar toggleSidebar={toggleSidebar}  isSidebarOpen={sidebarOpen}
                   isMobile={isMobile}/>
       

        {/* Page Content */}
        <div className="page-content container-xxl">
          {/* Page Header */}
          <div className="row mb-4">
            <div className="col-12">
              <div>
                <h4 className="fw-bold mb-1">
                  <i className="me-2" data-lucide="file-text"></i>
                  Fuel Deposit
                </h4>
                <p >View and manage all Fuel Deposit</p>
              </div>
            </div>
          </div>

          {/* Fuel Deposit Card */}
          <div className="row">
            <div className="col-12">
              <div className="card custom-card">
                <div className="top-left"></div>
                <div className="top-right"></div>
                <div className="bottom-left"></div>
                <div className="bottom-right"></div>
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-baseline mb-3">
                    <h6 className="card-title mb-0">
                      <i className="me-2" data-lucide="file-text"></i>
                      Fuel Deposit List
                    </h6>
                    {isLoading && (
                      <div className="spinner-border spinner-border-sm text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </div>

                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Sl no.</th>
                            <th>Payment Mode</th>
                             <th>Hash ID</th>
                          <th>Amount</th>
                            <th>Receiver Hash ID</th>
                          <th>Status</th>
                            <th>Comment</th>
                          <th>Created At</th>
                          <th>Updated At</th>
                       
                        </tr>
                      </thead>

<tbody>
    {isLoading ? (
        <tr>
            <td colSpan="10" className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2">Loading fuel deposits...</p>
            </td>
        </tr>
    ) : paymentReports.length > 0 ? (
        paymentReports.map((report, index) => {
            // Create unique IDs for copy functionality
            const paymentHashId = `payment-hash-${report.id}`;
            const receiverHashId = `receiver-hash-${report.id}`;
            
            return (
                <tr key={report.id}>
                    <td>{report.id}</td>
                    <td>
                        <span className="badge bg-info">
                            {report.payment_mode || 'N/A'}
                        </span>
                    </td>
                    
                    {/* Payment Hash ID */}
                    <td>
                        <div className="d-flex align-items-center gap-2 position-relative">
                            <small 
                                className="hash-text" 
                                title={report.payment_hash_id || 'N/A'}
                                style={{ 
                                    wordBreak: 'break-all',
                                    flex: 1,
                                    cursor: 'pointer',
                                    color: 'white'
                                }}
                                onClick={() => copyToClipboard(report.payment_hash_id, "Payment Hash ID", paymentHashId)}
                            >
                                {formatText(report.payment_hash_id, 15)}
                            </small>
                            <div className="position-relative">
                                <button
                                    className="btn btn-sm btn-outline-secondary p-1 copy-btn"
                                    onClick={() => copyToClipboard(report.payment_hash_id, "Payment Hash ID", paymentHashId)}
                                    title="Copy Payment Hash ID"
                                    style={{ 
                                        minWidth: '24px',
                                        minHeight: '24px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <MdContentCopy size={14} />
                                </button>
                                {copiedId === paymentHashId && (
                                    <div className="copy-tooltip">
                                        Copied!
                                    </div>
                                )}
                            </div>
                        </div>
                    </td>
                    
                    <td>
                        <span className="fw-bold text-success">
                            ${report.payment_amount ? parseFloat(report.payment_amount).toFixed(2) : '0.00'}
                        </span>
                    </td>
                    
                    {/* Receiver Hash ID */}
                    <td>
                        <div className="d-flex align-items-center gap-2 position-relative">
                            <small 
                                className="hash-text" 
                                title={report.payment_receive_hash_id || 'N/A'}
                                style={{ 
                                    wordBreak: 'break-all',
                                    flex: 1,
                                    cursor: 'pointer',
                                    color: 'white'
                                }}
                                onClick={() => copyToClipboard(report.payment_receive_hash_id, "Receiver Hash ID", receiverHashId)}
                            >
                                {formatText(report.payment_receive_hash_id, 15)}
                            </small>
                            <div className="position-relative">
                                <button
                                    className="btn btn-sm btn-outline-secondary p-1 copy-btn"
                                    onClick={() => copyToClipboard(report.payment_receive_hash_id, "Receiver Hash ID", receiverHashId)}
                                    title="Copy Receiver Hash ID"
                                    style={{ 
                                        minWidth: '24px',
                                        minHeight: '24px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <MdContentCopy size={14} />
                                </button>
                                {copiedId === receiverHashId && (
                                    <div className="copy-tooltip">
                                        Copied!
                                    </div>
                                )}
                            </div>
                        </div>
                    </td>
                    
                    <td>
                        <span className={`badge ${getStatusBadgeClass(report.payment_status)}`}>
                            {report.payment_status || 'Pending'}
                        </span>
                    </td>
                    
                    <td>
                        <small className="">
                            {report.payment_comment || 'No comment'}
                        </small>
                    </td>
                    
                    <td>
                        <small>{formatDate(report.created_at)}</small>
                    </td>
                    
                    <td>
                        <small>
                            {report.payment_status_update_at ? formatDate(report.payment_status_update_at) : 'N/A'}
                        </small>
                    </td>
                    
                  
                </tr>
            );
        })
    ) : (
        <tr>
            <td colSpan="10" className="text-center py-4">
                <i data-lucide="inbox" className="icon-lg mb-2"></i>
                <p className="mb-0">No fuel deposits found</p>
                <small className="text-muted d-block mt-1">
                    Submit a fuel deposit request to see it here
                </small>
                <button 
                    className="btn btn-sm btn-primary mt-2"
                    onClick={() => fetchPaymentReports()}
                >
                    <i className="me-1" data-lucide="refresh-cw"></i> Refresh
                </button>
            </td>
        </tr>
    )}
</tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer d-flex flex-row align-items-center justify-content-center px-4 py-3 border-top small">
          <p className="text-secondary mb-1 mb-md-0">Copyright © 2025 Willow Quantum. All Right Reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default FuelDeposit;